import React, { Component }from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle} from '../Common/style'

class InventoryConverts extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
            gourpOpen: false
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchInventoryConverts();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventoryConverts is ready, reset state.

    componentWillReceiveProps(nextProps) {
        const PT = nextProps.inventoryConverts;
        if (nextProps.inventoryConverts && nextProps.inventoryConverts != this.props.inventoryConverts) {
            this.setState({
                rows: nextProps.inventoryConverts
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    // Set inventoryConverts being selected to be currentInventoryConvert and navigate user to the edit page

    setCurrentInventoryConvert(e) {
        e.preventDefault();
        const currentInventoryConvert = this.state.selectedRows[0];
        this.props.resetCurrentInventoryConvert();
        this.props.selectInventoryConvert(currentInventoryConvert);
        this.context.router.push('/inventories/convert/' + currentInventoryConvert.WarehouseConvert_id)
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentInventoryConvert();
        this.context.router.push('/inventories/convert/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }


            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let rows = this.state.rows.slice(0);
                let editedRows = this.state.editedRows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                // if the element is already edited, remove the old one.
                editedRows.forEach((element, index) => {
                    if (element.Inventory_id === rows[e.rowIdx].Inventory_id)
                        editedRows.splice(index, 1)
                }, this);
                // push the row into the editedRows array
                editedRows.push(rows[e.rowIdx]);
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                    else return <span className="label label-danger"><Translate value="disable" /></span>;
                }
            });

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            // Column difinition

            const columns = [
              {
                  key: 'WarehouseConvertNum',
                  name: <Translate value="record_convert_no" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  locked: true
              },
              {
                  key: 'CreateTime',
                  name: <Translate value="create_date" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'PostingDate',
                  name: <Translate value="convert_date" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'Modify_Username',
                  name: <Translate value="convert_user" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'Note',
                  name: <Translate value="note" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'Completed',
                  name: <Translate value="completed" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryConverts-dataGrid1">
                    <ReactDataGrid
                        rowKey='WarehouseConvert_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={this.state.tableHeight}
                        enableRowSelect='single'
                        onRowUpdated={handleRowUpdated}
                        onRowSelect={onRowSelect}
                        />
                </div></Col></Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        return (
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="warehouse_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="inventory_convert" />
                </Breadcrumb.Item>
              </Breadcrumb> {/* End Nav Trail */}
              <Grid id="inventory-convert">
                <Row><Col sm={ 12 }>
                    <Link to="/inventories"  className="btn btn-green marginLeftStyle" ><em className="fa fa-mail-reply"/></Link>
                    <Button className="btn btn-primary marginLeftStyle" onClick={(e) => this.clickNew(e) } disabled={this.checkPermission("add_warehouse_convert")}>
                        <em className="fa fa-plus marginRightStyle" /><Translate value="create_inventory_convert_sheet" />
                    </Button>
                    <div className="pull-right">
                        <Button className="btn btn-primary marginLeftStyle" >
                            <em className="fa fa-print marginRightStyle" /><Translate value="print" />
                        </Button>
                        <Button className="btn btn-primary marginLeftStyle" >
                            <em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                        </Button>
                        <Button
                          className="btn btn-primary marginLeftStyle"
                          onClick={(event) => {this.setCurrentInventoryConvert(event)}}>
                            <em className="fa fa-pencil marginRightStyle" /><Translate value="edit" />
                        </Button>
                    </div>
                </Col></Row>
                <br/>
                {this.renderTable() }
              </Grid>
            </ContentWrapper>
        );
    }
}



export default InventoryConverts;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryConverts.jsx